
<img class="right-oval" src="assets/img/ovals/grey-oval-right.png"/>

<ion-content>

  <ion-menu-toggle class="SCWEB-menu-icon">
    <ion-button color="white">
      <img src="assets/img/shortcut-icon.png" class="SCWEB-menu-img" />
    </ion-button>
  </ion-menu-toggle>

  <!-- <div class="SCWEB-address-container" (click)="openSccToThisPage()">
    <p>Additional settings</p>
    <ion-icon name="arrow-redo-circle-outline"></ion-icon>
  </div> -->

  <div class="page-wrapper" *ngIf="userService.business">

    <div class="name-img-wrapper">
      <img [src]="userService.business.pic" class="img" />
      <div class="name">{{userService.business.name}}</div>
    </div>

    <div class="middle-info">

      <div class="section-header">Business contact information</div>

      <ion-item class="input-item bottom-border" lines="none" *ngIf="userService.business.ownerFullName">
        <ion-label>{{userService.business.ownerFullName}}</ion-label>
      </ion-item>

      <ion-item class="input-item bottom-border" lines="none">
        <ion-label>{{userService.user.email}}</ion-label>
      </ion-item>

      <ion-item class="input-item bottom-border" lines="none">
        <ion-label>{{userService.business.nationalPhoneNumber}}</ion-label>
      </ion-item>

      <ion-item class="item-with-subtext hoverable bottom-border" lines="none" (click)="copyLink()">
        <ion-label>
          {{businessLink()}}
          <p class="subtext">Click to copy</p>
        </ion-label>
      </ion-item>

      <!-- <hr> -->

      <ion-item class="item-with-subtext hoverable" lines="none" (click)="viewLocations()">
        <ion-label>
          View/add locations
          <p class="error-placeholder" *ngIf="!userService.business.numLocations">Missing: Please add at least one location.</p>
          <p class="subtext" *ngIf="userService.business.numLocations">{{userService.business.numLocations}} location(s) active.</p>
        </ion-label>
      </ion-item>

      <!-- <div class="section-header">Stripe account</div> -->

      <!-- <div *ngIf="!userService.business.stripeAccountID">
        <ion-item class="input-item ion-text-wrap" lines="none">
          <ion-label>
            <p style="margin-top: 16px">Please set up your Stripe account to receive direct deposit payments when your Pros get an order.</p>
          </ion-label>
        </ion-item>

        <ion-item class="input-item clickable" lines="none" (click)="setUpStripe()" *ngIf="!userService.business.stripeAccountID">
          <ion-icon class="start-icon" slot="start" name="cut-outline"></ion-icon>
          <ion-label> Set up Stripe account </ion-label>
          <ion-icon class="end-icon" slot="end" name="chevron-forward-outline"></ion-icon>
        </ion-item>
      </div> -->
<!--
      <div>
        <ion-item class="input-item ion-text-wrap" lines="none">
          <ion-label>
            <p style="margin-top: 16px">You will receive direct deposits through Stripe 24-48 hours after appointment completion.</p>
          </ion-label>
        </ion-item>

        <ion-item class="input-item clickable" lines="none" (click)="viewStripe()" *ngIf="userService.business.stripeAccountID">
          <ion-icon class="start-icon" slot="start" name="cut-outline"></ion-icon>
          <ion-label> View Stripe account by location </ion-label>
          <ion-icon class="end-icon" slot="end" name="chevron-forward-outline"></ion-icon>
        </ion-item>
      </div> -->

      <div class="section-header">Subscription</div>

      <ion-item class="input-item bottom-border clickable" lines="none" (click)="updatePayment()">
        <ion-icon class="start-icon" slot="start" name="card"></ion-icon>
        <ion-label> {{ paymentCardString }} </ion-label>
        <ion-icon class="end-icon" slot="end" name="chevron-forward-outline"></ion-icon>
      </ion-item>

      <ion-item class="item-with-subtext" lines="none">
        <ion-label>
          Your card will be charged automatically
          <p>when a subscription payment is due.</p>
        </ion-label>
      </ion-item>

      <!-- <ion-item class="input-item" lines="none">
        <ion-label> Charge: ${{userService.business.subRatePerPro}} monthly per active Pro</ion-label>
      </ion-item> -->

      <div class="section-header">Commission structure</div>

      <ion-item class="input-item bottom-border">
        <ion-label> Shortcut transaction fee: <b>{{formatPercentage(1 - userService.business.businessTotalCommission)}}</b></ion-label>
      </ion-item>

      <ion-item class="commission-tiers" lines="none">
        <ion-label>
          Pro service commission tiers
          <div class="commission-options">
            <p class="commission-tier" *ngFor="let c of commissionOptions">
              {{c.name}}: {{formatPercentage(c.commission)}}
            </p>
            <p *ngIf="commissionOptions && commissionOptions.length == 0" class="commission-missing">Missing: Please add at least one commission tier.</p>
            <p><span (click)="promptAddCommissionOption()" class="add-option">
              <ion-icon name="add-outline"></ion-icon>
              Add option
            </span></p>
          </div>
        </ion-label>
      </ion-item>

      <!-- <ion-item class="input-item clickable" lines="none">
        <ion-icon class="start-icon" slot="start" name="gift"></ion-icon>
        <ion-label>Gift cards</ion-label>
        <ion-icon class="end-icon" slot="end" name="chevron-forward-outline"></ion-icon>
      </ion-item> -->

      <!-- <ion-item class="input-item clickable" lines="none">
        <ion-icon class="start-icon" slot="start" name="cut"></ion-icon>
        <ion-label>Get free cuts</ion-label>
        <ion-icon class="end-icon" slot="end" name="chevron-forward-outline"></ion-icon>
      </ion-item> -->

      <p class="reset-pass-button" (click)="resetPassword()">Reset password</p>
      <p class="log-out-button" (click)="logOut()">Log out</p>

      <br><br>

    </div>
  </div>

</ion-content>

<ion-footer slot="fixed" class="SC-support-footer">
  <span class="support-button" (click)="openPage('https://getshortcut.co/faq')">FAQ</span>
  <span class="support-button" (click)="adminChat()">Live chat</span>
  <span class="support-button" (click)="openPage('https://getshortcut.co/privacy')">Privacy policy</span>
  <span class="support-button" (click)="openPage('https://getshortcut.co/terms')">Terms of service</span>
</ion-footer>